<template>
    <div class="main" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>积分</el-breadcrumb-item>
            <el-breadcrumb-item>积分设置</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt fromBox">
                    <div class="">
                        <div class="" :title="title" hidden-breadcrumb>
                            <div slot="content">
                                <Form class="ivu-col ivu-col-span-13 form-submit input-build" :model="formItem" :label-width="200">
                                    <Tabs v-model="currentTab">
                                        <TabPane :label="item.label" :name="item.value.toString()" v-for="(item,index) in headerList" :key="index">
                                            <div>
                                                <FormItem label="积分抵扣比例" prop="is_open">
                                                    <div class="acea-row row-middle">
                                                        1个元可抵扣
                                                        <InputNumber style="margin-left: 10px" placeholder="" :min="1" :precision="0" v-model="formItem.discount.discount_ratio" class="perW20"/><span class="ml" style="margin-left: 10px">积分</span>
                                                    </div>
                                                    <div class="info-wrapper">
                                                        例如：0.01元可抵扣1积分，1元则可抵扣100积分，10元则可抵扣1000积分
                                                    </div>
                                                </FormItem>
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </Form>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="fixed-card">
                            <Card :bordered="false" dis-hover class="ivu-mt fromBox">
                                <Button type="primary" @click="onSubmit">提交</Button>
                            </Card>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "../second.vue";
    export default {
        name: "index",
        components: { second },
        data () {
            return {
                isLoad: false,
                currentTab: '',
                headerList: [
                    {
                        label: '基础设置',
                        value: 'basic'
                    },
                ],
                title: '',
                key: 'payment',
                formItem: {
                },
                ruleValidate: {
                },
                loading: false
            }
        },
        // 初始化数据
        created () {
            // 获取当前详情记录
            this.getDetail()
        },
        methods: {
            getDetail: function () {
                let that = this;
                that.loading = true;
                this.axios.post('/store/setting/detail',{
                    'key': 'jifen'
                })
                .then(async (res) => {
                    if (res.code == 1 && res.data.values) {
                        that.formItem = res.data.values
                    }
                })
                .catch((res) => {
                    that.loading = false;
                    that.$message.error(res.msg);
                });
            },
            onSubmit: function () {
                var that = this

                this.axios.post('/store/setting/update',{
                    'key': 'jifen',
                    form: this.formItem,
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$Message.success(res.msg);
                    }
                })
                .catch((res) => {
                    that.loading = false;
                    that.$Message.error(res.msg);
                });
            }
        }
    }
</script>

<style scoped>

</style>
